module.exports = __webpack_public_path__ + "images/assets/3bb5abd289504f293b529e935a9f0c88.svg";